<template>
  <div class="new-guide-step-2">
    <form-item label="分布区间">
      <div class="distribute-region-cont">
        <t-radio-group v-model="localDistributionRegion.type" @change="handleChangeType" class="type-radio-group">
          <t-radio :value="1">快捷区间</t-radio>
          <t-radio :value="2">自定义区间</t-radio>
        </t-radio-group>
        <div class="region-config-item" v-if="localDistributionRegion.type === 1">
          <label class="region-config-label">分组</label>
          <t-select
            ref="eventRef"
            v-model="localDistributionRegion.group"
            placeholder="请选择"
            filterable
            class="region-config-select"
          >
            <t-option label="智能分组" :value="-1" />
            <t-option label="5等分" :value="5" />
            <t-option label="10等分" :value="10" />
            <t-option label="15等分" :value="15" />
            <t-option label="自定义步长" :value="0" />
          </t-select>
        </div>
        <div
          class="region-config-item"
          v-if="localDistributionRegion.type === 1 && localDistributionRegion.group === 0"
        >
          <label class="region-config-label">间隔</label>
          <t-input-number
            theme="column"
            :decimalPlaces="0"
            :min="0"
            v-model.number="localDistributionRegion.interval"
            class="region-config-input"
          ></t-input-number>
        </div>
        <div class="region-config-item" v-if="localDistributionRegion.type === 2">
          <label class="region-config-label">区间步长</label>
          <ul class="interval-custom-config-cont">
            <li v-for="(item, index) in localDistributionRegion.intervalArr" :key="index">
              <span class="interval-index">{{ index + 1 }}</span>
              <span>{{ index === 0 ? '(' : '[' }}</span>
              <span v-if="index === 0" class="interval-start">{{ item.start }}</span>
              <t-input-number
                theme="column"
                :min="0"
                v-if="index !== 0"
                v-model="localDistributionRegion.intervalArr[index].start"
                disabled
                placeholder="请输入数字"
                class="interval-start"
              ></t-input-number>
              <span>,</span>
              <span v-if="index === localDistributionRegion.intervalArr.length - 1" class="interval-end">
                {{ item.end }}
              </span>
              <t-input-number
                theme="column"
                :min="
                  localDistributionRegion.intervalArr[index].start === '-∞'
                    ? -99999999999999
                    : localDistributionRegion.intervalArr[index].start + 1
                "
                v-if="index !== localDistributionRegion.intervalArr.length - 1"
                v-model="localDistributionRegion.intervalArr[index].end"
                placeholder="请输入数字"
                class="interval-end"
                :class="{ error: checkValueIsError(index) }"
                @change="handleChangeEnd(index)"
              ></t-input-number>
              <span>{{ index === localDistributionRegion.intervalArr.length - 1 ? ')' : ']' }}</span>
              <t-button
                size="small"
                variant="text"
                theme="primary"
                v-if="index < localDistributionRegion.intervalArr.length - 1"
                @click="handleAddIntervalItem(index)"
              >
                + 区间
              </t-button>
              <t-button
                size="small"
                variant="text"
                theme="primary"
                v-if="index !== 0 && index < localDistributionRegion.intervalArr.length - 1"
                @click="handleDelIntervalItem(index)"
              >
                删除
              </t-button>
            </li>
          </ul>
        </div>
      </div>
    </form-item>
  </div>
</template>

<script>
import lodash from 'lodash';
import FormItem from './form-item.vue';
import ConditionFilter from '@/components/analysis/condition-filter.vue';

export default {
  name: 'DistributeRegion',
  components: {
    FormItem,
    ConditionFilter,
  },
  model: {
    prop: 'distributionRegion',
    event: 'change',
  },
  props: {
    distributionRegion: {
      type: Object,
      default: () => {
        return {
          type: 1,
          group: -1,
          interval: 20,
          intervalArr: [
            { start: '-∞', end: 20 },
            { start: 20, end: '+∞' },
          ],
        };
      },
    },
  },
  data() {
    return {
      dialogVisible: false,

      localDistributionRegion: lodash.cloneDeep(this.distributionRegion),
    };
  },
  watch: {
    distributionRegion: {
      handler() {
        if (JSON.stringify(this.distributionRegion) !== JSON.stringify(this.localDistributionRegion)) {
          this.localDistributionRegion = lodash.cloneDeep(this.distributionRegion);
        }
      },
      deep: true,
    },
    localDistributionRegion: {
      handler() {
        this.$emit('change', lodash.cloneDeep(this.localDistributionRegion));
      },
      deep: true,
    },
  },
  methods: {
    handleChangeType() {
      this.localDistributionRegion.group = -1;
      this.localDistributionRegion.interval = 20;
      this.localDistributionRegion.intervalArr = [
        { start: '-∞', end: 20 },
        { start: 20, end: '+∞' },
      ];
    },
    handleAddIntervalItem(index) {
      const preItem = this.localDistributionRegion.intervalArr[index];
      const nextItem = this.localDistributionRegion.intervalArr[index + 1];
      this.localDistributionRegion.intervalArr.splice(index + 1, 0, {
        start: preItem.end,
        end: nextItem.start,
      });
    },
    handleDelIntervalItem(index) {
      const preItem = this.localDistributionRegion.intervalArr[index - 1];
      const nextItem = this.localDistributionRegion.intervalArr[index + 1];
      nextItem.start = preItem.end;

      this.localDistributionRegion.intervalArr.splice(index, 1);
    },

    handleChangeEnd(index) {
      const { end } = this.localDistributionRegion.intervalArr[index];
      this.localDistributionRegion.intervalArr[index + 1].start = end;
    },

    checkValueIsError(index) {
      if (index === 0 || index === this.localDistributionRegion.intervalArr.length - 1) {
        return false;
      }
      return (
        this.localDistributionRegion.intervalArr[index].start >= this.localDistributionRegion.intervalArr[index].end
      );
    },
  },
};
</script>
<style lang="less" scoped>
.distribute-region-cont {
  width: 100%;
  ::v-deep .type-radio-group {
    .t-radio__label {
      font-size: 12px;
    }
  }
  .region-config-item {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 12px;
    .region-config-label {
      flex: 0 0 auto;
      margin-right: 12px;
    }
    .region-config-input,
    .region-config-select {
      width: 208px;
    }
    .interval-custom-config-cont {
      flex: 1 1 auto;
      background: #fafafa;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 12px;

      li {
        list-style: none;
        display: flex;
        align-items: center;

        &:not(:last-child) {
          margin-bottom: 12px;
        }

        span {
          margin-right: 12px;
        }

        .interval-start,
        .interval-end {
          width: 100px;
          margin-right: 12px;
        }

        .interval-index {
          width: 20px;
          height: 20px;
          box-sizing: border-box;
          border-radius: 50%;
          border: 1px solid #5a66ff;
          font-weight: bold;
          font-size: 14px;
          color: #5a66ff;
          line-height: 18px;
          margin-right: 8px;
          text-align: center;
        }
      }
    }
  }
}

::v-deep .error {
  .t-input {
    border-color: red;
  }
}
</style>
